module.exports = __webpack_public_path__ + "img/zizhi1.055af030.jpg";